var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    width: 156.47,
    height: 312.94,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.22 313.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: red;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.37,
    y: 0.37,
    width: 156.47,
    height: 312.94
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedborder);
export default __webpack_public_path__ + "static/media/redborder.8037463c78104d6184a1f0436e25f1ae.svg";
export { ForwardRef as ReactComponent };